import { createSelector } from 'reselect';
import { Store } from '../../../store/store.model';

export const selectLocationsV2 = (state: Store) => state.locationsV2 || {};

export const selectLocationV2ById = (locationId: string) =>
  createSelector(selectLocationsV2, (locationsV2) => locationsV2[locationId] || null);

export const selectCurrentLocationV2 = createSelector(
  selectLocationsV2,
  (state: Store) => state.currentLocationId,
  (locationsV2, currentLocationId) =>
    currentLocationId ? locationsV2[currentLocationId] : null
);
